import React from 'react';
import {drawerRoutes} from '../../router/mainRoutes/drawerRoutes';
import {DrawerItem} from '../../interfaces/router/drawerItem';
import {tr} from '../../translations';
import styled from 'styled-components/native';
import {FlatList} from 'react-native';
import {DrawerMainListProps} from '../../interfaces/components/drawerMainList';
import SideMenuListItem from '../sideMenuListItem';

const Container = styled.View`
  width: 100%;
`;

const DrawerMainList = ({onItemPress}: DrawerMainListProps) => {
  // Define a keyExtractor function for FlatList
  const keyExtractor = (item: DrawerItem) => item.name;

  // Define the renderItem function for FlatList
  const renderItem = ({item}: {item: DrawerItem}) => {
    if (!item.iconName) {
      return null;
    }
    return (
      <SideMenuListItem
        onPress={() => onItemPress(item)}
        iconName={item.iconName}
        title={tr(`drawer.${item.name}`)}
        showArrow={item.isSubScreen}
      />
    );
  };

  return (
    <Container>
      <FlatList
        scrollEnabled={false}
        data={drawerRoutes}
        renderItem={renderItem}
        keyExtractor={keyExtractor}
      />
    </Container>
  );
};

export default React.memo(DrawerMainList); // Wrap with React.memo
